export default function rollDice(numDice: number): number[] {
    let result: number[] = [];
    for (let i = 0; i < numDice; i++) {
        result.push(Math.floor(Math.random() * 10) + 1);
    }
    return result;
}

export function RollDiceSummed(numDice: number): number {
    let result: number = 0;
    let dice: number[] = rollDice(numDice);
    for (var i: number = 0; i < numDice; i++) {
        result += dice[i];
    }
    return result;
}